import type { IconData } from '@stacksjs/iconify-core'

export const compass: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m209.686 304.963l119.051 59.424a24 24 0 0 0 32.182-32.21l-59.5-118.948l-119.086-59.645a24 24 0 0 0-32.216 32.189Zm67.88-67.892l44.006 87.975l-88.037-43.946l-44.056-88.149Z\"/><path fill=\"currentColor\" d=\"M256 496c132.548 0 240-107.452 240-240S388.548 16 256 16S16 123.452 16 256s107.452 240 240 240M48.353 244C54.269 140.018 136.553 56.476 240 48.606V115h32V48.606C375.447 56.476 457.731 140.018 463.647 244h-63.676v32h63.068C453.474 376.238 372.78 455.727 272 463.394V403h-32v60.394C139.22 455.727 58.526 376.238 48.961 276h63.01v-32Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default compass
